import { Component, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Observable, Subject } from "rxjs";
import { Location } from '@angular/common';
// Model
import { URLS } from "../../models/partial-integration.model";
import { PartialIntegrationService } from "../../services/data-loader-partial-integration.service";
import { PartialIntegrationComponent } from "../../partial-integration.component";

@Component({
	selector: 'cv-partial-header',
	templateUrl: './partial-header.component.html',
	styleUrls: ['./partial-header.component.scss']
})
export class PartialHeaderComponent implements OnInit, OnDestroy {
	private atComponentDestroy: Subject<any> = new Subject<any>();
	headerSubtitle: string;
	
	constructor(
		private router: Router,
		private location: Location,
		private partialIntegrationService: PartialIntegrationService,
	){}

	/**
	 * define the title according to the URL
	 */
	ngOnInit(): void {
		this.headerSubtitle = '';
		
		switch(true) {
			case this.router.url.includes(URLS.RELIANCE_FIRST):
				this.headerSubtitle = 'Reliance First Orders';
			break;
			case this.router.url.includes(URLS.RELIANCE_FIRST_DETAIL):
				this.headerSubtitle = 'Relianace First Logs';
			break;
			case this.router.url.includes(URLS.MI_MUTUAL):
				this.headerSubtitle = 'Mi Mutual Orders'; 
			break;
			case this.router.url.includes(URLS.MI_MUTUAL_DETAIL):
				this.headerSubtitle = 'Mi Mutual Logs'; 
			break;
		}
	}

	/**
	 * Go back
	 */
	goBack(): void {
		this.location.back();
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.unsubscribe();
	}

	/**
	 * Calls a service to communicate with the Inbox component and reload the grid
	 */
	reloadList(): void {
		const origin = this.router.url.includes('logs')? 'logs' : 'orders';
		this.partialIntegrationService.reloadList({ 
			reload: true, 
			origin: origin
		});
	}
}